import React from 'react'
import {Box, Skeleton, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useItemVariant} from '@salesforce/retail-react-app/app/components/item-variant'

import {FormattedNumber} from 'react-intl'
import PropTypes from 'prop-types'
import {getPriceData} from '../../../utils/product-utils'
import {remCalc} from '../../../theme/_utils'

const UnitPrice = ({
    currency,
    style,
    hasStrikethrough = false,
    orderDetail,
    isCart,
    isFreeItemPromo = false,
}) => {
    const variant = useItemVariant()
    let priceData

    if (orderDetail) {
        priceData = {
            ...(hasStrikethrough
                ? {listPrice: orderDetail?.ListPrice}
                : {pricePerUnit: orderDetail?.UnitPrice}),
        }
    } else {
        // for wishlist page we extract price info from variant/product obj
        priceData = getPriceData(variant)
    }

    return (
        <Box {...(style ?? null)}>
            {currency &&
            (priceData?.listPrice !== undefined || priceData?.pricePerUnit !== undefined) ? (
                <Text>
                    <FormattedNumber
                        style="currency"
                        currency={currency}
                        currencyDisplay="narrowSymbol"
                        value={
                            isFreeItemPromo
                                ? priceData?.unitPrice
                                : hasStrikethrough
                                ? priceData?.listPrice
                                : isCart &&
                                  priceData?.unitPrice < priceData?.pricePerUnit &&
                                  priceData?.unitPrice !== 0
                                ? priceData?.unitPrice
                                : priceData?.pricePerUnit
                        }
                    />
                </Text>
            ) : (
                <Skeleton h={remCalc(20)} w="100%" />
            )}
        </Box>
    )
}

UnitPrice.propTypes = {
    currency: PropTypes.string,
    style: PropTypes.object,
    hasStrikethrough: PropTypes.bool,
    orderDetail: PropTypes.object,
    isCart: PropTypes.bool,
    isFreeItemPromo: PropTypes.bool,
}
export default UnitPrice
